<div class="account-dropdown-wrapper" fxLayout="row" fxLayoutAlign="start center">
    <div class="football-icon" (click)="onFootballIconClick()">
        <mat-icon class="football-guide-icon">sports_soccer</mat-icon>
    </div>

    <div class="notification-icon" (click)="onNotificationBellClick($event)">
        <mat-icon class="notification-bell-icon">{{ unreadNotificationCount > 0 ? 'notifications' : 'notifications_none' }}</mat-icon>
        <span class="notification-badge" *ngIf="unreadNotificationCount > 0"
              [attr.aria-label]="unreadNotificationBadge + ' okunmamış bildirim'">{{ unreadNotificationBadge }}</span>
    </div>

    <!-- role=button: MatMenuTrigger aria-haspopup/aria-expanded ekler, bunlar rolsüz div'de geçersiz (aria-allowed-attr) -->
    <div class="account-menu timer-sibling mobile-app-hide"[ngClass]="{'timer-sibling': showTimerInHeader()}"
         [matMenuTriggerFor]="accountMenu"
         role="button" tabindex="0"
         fxLayout="row">
        <!--  -->
        <div class="account-menu-wrapper"
             fxLayout="row"
             fxLayoutGap="8px">

            <div class="account-icon">
                <img src="assets/images/icon/profile.svg"
                     alt="Profile">
            </div>

            <!-- Görünürlük SCSS'te; bkz. top-band.component.scss başındaki ngx-layout/SSR notu. -->
            <div class="account-info-text-wrapper">
                <!--      -->
                <div class="title">{{'account.title'|translate}}
                    <mat-icon class="chevron-icon"
                              color="primary">
                        expand_more
                    </mat-icon>
                </div>
                <!--     -->
                <div class="user-name-text">
                    {{this.isAuthenticated ? loggedInUserName : ('auth.labels.signInOrSignUp'|translate)}}
                </div>
            </div>

        </div>
    </div>
</div>


<!--  Account Menu    -->
<mat-menu #accountMenu="matMenu"
          xPosition="before">


    <!--  TODO: Seam devre dışı kalınca burası düzenlenecek.-->
    <ng-container *ngFor="let menuItem of menuItems">
        <a mat-menu-item
           *ngIf="menuItem.external else internalLink"
           [href]="menuItem.url">
            <mat-icon class="material-icons-outlined"
                      *ngIf="menuItem.icon">{{menuItem.icon}}</mat-icon>
            <span [translate]="menuItem.label"></span>
        </a>

        <!--  -->
        <ng-template #internalLink>
            <a mat-menu-item
               [routerLink]="[menuItem.url]">
                <mat-icon class="material-icons-outlined"
                          *ngIf="menuItem.icon">{{menuItem.icon}}</mat-icon>
                <span [translate]="menuItem.label"></span>
            </a>
        </ng-template>
    </ng-container>


    <!--    Logout Button          -->
    <ng-container *ngIf="isAuthenticated">

        <!--      Logout        -->
        <button mat-menu-item
                class="btn-logout"
                color="warn"
                (click)="doLogout()">
            <mat-icon>logout</mat-icon>
            {{'shared.labels.logout'|translate}}
        </button>

    </ng-container>

</mat-menu>
